import NewButton from "../Button/Button";

export default function DeprecatedButton({
  text,
  className,
  onClick,
  dark = false,
  disabled = false,
}) {
  return (
    <NewButton
      className={
        (className || "") +
        (dark
          ? " bg-white text-blueGray active:bg-blueGray-500"
          : " bg-blueGray-700 text-white active:bg-blueGray-400")
      }
      type="submit"
      disabled={disabled}
      onClick={onClick}
    >
      {text}
    </NewButton>
  );
}
